interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
}

export function Loader({ size = 'md', text, className = '' }: LoaderProps) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  };

  const borderSizeClasses = {
    sm: 'border-2',
    md: 'border-2',
    lg: 'border-4',
  };

  return (
    <div className={`flex flex-col items-center justify-center gap-4 ${className}`}>
      <div
        className={`${sizeClasses[size]} ${borderSizeClasses[size]} border-brand-accent/30 border-t-brand-accent rounded-full animate-spin`}
        style={{
          animation: 'spin 1s linear infinite',
        }}
      />
      {text && (
        <p className="text-neutral-medium font-body text-sm animate-pulse">{text}</p>
      )}
    </div>
  );
}

// Inline spinner for buttons
interface ButtonSpinnerProps {
  size?: 'xs' | 'sm';
  className?: string;
}

export function ButtonSpinner({ size = 'xs', className = '' }: ButtonSpinnerProps) {
  const sizeClasses = {
    xs: 'w-4 h-4',
    sm: 'w-5 h-5',
  };

  const borderSizeClasses = {
    xs: 'border-2',
    sm: 'border-2',
  };

  return (
    <div
      className={`${sizeClasses[size]} ${borderSizeClasses[size]} border-current/30 border-t-current rounded-full animate-spin inline-block ${className}`}
      style={{
        animation: 'spin 1s linear infinite',
      }}
    />
  );
}
